import { ShippingMethod } from '../../core/enums/woo-commerce/shipping/shipping.enum';
import { OptionSwitcherItem } from '../interfaces/option-switcher.interface';

export const SHIPPING_OPTIONS: OptionSwitcherItem[] = [
  {
    id: ShippingMethod.Delivery,
    name: 'Delivery',
    icon: 'icon icon-delivery-outline',
    description: ''
  },
  {
    id: ShippingMethod.Pickup,
    name: 'Pickup',
    icon: 'icon icon-bag-outline',
    description: ''
  }
];

export interface ShippingOptionsAvailability {
  delivery_enabled: boolean;
  pickup_enabled: boolean;
}

// TODO: FIX THIS PLEASE (FAST FIX) 🙄
export function getShippingOptions(
  deliveryDescription: string,
  pickupDescription: string,
  availability?: ShippingOptionsAvailability
) {
  const options: OptionSwitcherItem[] = JSON.parse(JSON.stringify(SHIPPING_OPTIONS));
  options[0].description = deliveryDescription;
  options[1].description = pickupDescription;

  if (availability) {
    if (!availability.delivery_enabled) {
      options[0].disabled = true;
      options[0].tooltip = 'Delivery is currently unavailable';
    }
    if (!availability.pickup_enabled) {
      options[1].disabled = true;
      options[1].tooltip = 'Pickup is currently unavailable';
    }
  }

  return options;
}
